import { Region } from '@heidi/schema/ml-scribe';

import { COMPLIANCE_LINKS } from '@/app-shell/app-root/legalDocuments';
import { countriesToRegion } from '@/lists/countriesToRegion';

const privacyPolicyLinks = {
  en: 'https://www.heidihealth.com/legal/privacy-policy',
  de: 'https://www.heidihealth.com/de-de/legal/privacy-policy',
  fr: 'https://www.heidihealth.com/fr-fr/legal/privacy-policy',
  es: 'https://www.heidihealth.com/es-es/legal/privacy-policy',
  it: 'https://www.heidihealth.com/legal/privacy-policy',
  ja: 'https://www.heidihealth.com/legal/privacy-policy',
  zh: 'https://www.heidihealth.com/legal/privacy-policy',
};

export const getPrivacyPolicyLink = (country?: string, locale?: string) => {
  if (locale) {
    const link = privacyPolicyLinks[locale as keyof typeof privacyPolicyLinks];
    if (link) {
      return link;
    }
  }

  if (!country) {
    return COMPLIANCE_LINKS.GDPR;
  }

  const region = countriesToRegion[country];

  if (!region) {
    return COMPLIANCE_LINKS.GDPR;
  }

  switch (region) {
    case Region.US:
      return COMPLIANCE_LINKS.HIPAA;
    case Region.UK:
      return COMPLIANCE_LINKS.GDPR;
    case Region.AU:
      return COMPLIANCE_LINKS.APP;
    case Region.CA:
      return COMPLIANCE_LINKS.CANADA;
    default:
      return COMPLIANCE_LINKS.GDPR;
  }
};
